import React from "react";
import { Col } from "react-bootstrap";
import { Row } from "react-bootstrap";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Dropdown from 'react-bootstrap/Dropdown'
import "./AppSideBar.css";
import Delishop from '../assets/icons/delishop_logo2.svg';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, ListItemIcon, ListItemText, withStyles } from "@material-ui/core";
import { RiLogoutBoxRLine } from "react-icons/ri";
import styled  from 'styled-components';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  large: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: { // Adjust this based on your breakpoint system
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
  },
}));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.black,
      },
    },
    width:'160px'
  },
}))(MenuItem);
function SupplierHeader () {

  let supplier = localStorage.getItem("supplier");
  const clearData = (() => {
    localStorage.removeItem('supplier');
    localStorage.removeItem('token');
    window.location.href = "/";
  });
  if(!supplier) {
    window.location.href = "/";
  }
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const dropDownToggle = (isOpen, event, metadata) => {
    event.stopPropagation();

    console.log(isOpen, metadata)
  };

  return (
    <div className="Header">
      <Row>
        <Col sm={1} xs={6}>
          <ImageDelishopLogo className=''>
            <img src={Delishop} style={{maxWidth: 180}} alt='Error Image Display' />
          </ImageDelishopLogo>
        </Col>
        <Col sm={11} xs={6}>
            <Avatar 
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle} 
              src="/" 
              className={'float-right '+classes.large} 
            />
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{zIndex:'9999'}}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <StyledMenuItem onClick={clearData}>
                        <RiLogoutBoxRLine style={{fontSize:"25px"}}/>
                      <ListItemText primary="Logout" />
                    </StyledMenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
        </Col>
      </Row>
        
    </div>
  );
};

const ImageDelishopLogo = styled.div`
    width: 160px;
    @media screen and (max-width: 600px) {
      img{
        width: 100px;
        float: left;
      }
        /* margin-top: 30px !important; */
    }
`;

export default SupplierHeader;
